export const defaultFormUrlsValue = {
  formUrlForPC: "",
  formUrlForMobile: "",
  formUrlForTablet: "",
  formUrlMatchType: "EQUAL_TYPE",
  formQueryMatchType: "EQUAL_MATCH",
  formIsEnableWhiteout: false,
  formIsSpa: false,
  formUrlRegularExpression: "",
};
